import ExternalOrderingButton from 'components/external-ordering-button/external-ordering-button.component';
import styled from 'styled-components';

export const ExternalOrderButton = styled(ExternalOrderingButton)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;
